require("@rails/ujs").start()

import '../app/app'

